import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_BASE = process.env.REACT_APP_API_BASE;

/**
 * fetch all Referrals entries
 */

export const fetchReferralsItems = createAsyncThunk(
  "referrals/fetchItems",
  async (vendorId, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/referrals?vendor_id=${vendorId}`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }

    const json = await res.json();

    if (!res.ok) {
      throw new Error(json?.message || "Fetch failed");
    }

    return json;
  }
);
export const fetchReferralsItemsByMemberID = createAsyncThunk(
  "referrals/fetchItemsByMemberID",
  async (memberId, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/referrals?member_id=${memberId}`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }

    const json = await res.json();

    if (!res.ok) {
      throw new Error(json?.message || "Fetch failed");
    }

    return json;
  }
);
export const fetchReferralByID = createAsyncThunk(
  "referrals/fetchById",
  async (ReferralId, thunkAPI) => {
    const res = await fetch(
      `${API_BASE}/api/referrals/getByParam?_id=${ReferralId}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }

    const json = await res.json();

    if (!res.ok) {
      throw new Error(json?.message || "Fetch failed");
    }

    return json;
  }
);

export const updateReferral = createAsyncThunk(
  "referrals/updateReferral",
  async ({ _id, referral_status, notes, lost_reason }, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/referrals/?_id=${_id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
      body: JSON.stringify({
        referral_status,
        notes,
        lost_reason,
      }),
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();

    if (!res.ok) {
      throw new Error(json?.message || "Update failed");
    }

    return json;
  }
);

export const createReferral = createAsyncThunk(
  "referrals/createReferral",
  async (payload, { rejectWithValue }, thunkAPI) => {
    try {
      const res = await fetch(`${API_BASE}/api/referrals`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
        body: JSON.stringify(payload),
      });
      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }
      const json = await res.json();

      if (!res.ok) {
        return rejectWithValue(json?.message || "Referral creation failed");
      }

      return json;
    } catch (error) {
      return rejectWithValue(error.message || "Unexpected error");
    }
  }
);
